module.exports = __webpack_public_path__ + "static/media/eye-close.dca295ec.svg";